module.exports = __webpack_public_path__ + "static/img/1_4_1.c6a3bdc8.jpg";